var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"municipalities-container"},[_c('h2',{staticClass:"heading-m"},[_vm._v(" "+_vm._s(_vm.countyName)+" ")]),_c('tws-close2-icon',{on:{"click":function($event){return _vm.$emit('close')}}}),_c('tws-rich-text',{attrs:{"html":_vm.text}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }